<template>
  <div>
    <v-container>
      <v-carousel cycle hide-delimiter-background hide-delimiters height="auto">
        <v-carousel-item>
          <v-img src="/img/LineRichmenu/banner/banner-06.png"></v-img>
        </v-carousel-item>
        <v-carousel-item>
          <v-img src="/img/LineRichmenu/banner/banner-03.png"></v-img>
        </v-carousel-item>
        <v-carousel-item>
          <v-img src="/img/LineRichmenu/banner/banner-04.png"></v-img>
        </v-carousel-item>
      </v-carousel>

      <v-container class="page__wrapper pa-4">
        <v-row style="position: relative">
          <v-btn
            color="primary btn-custom"
            :href="how_to_use_blog"
            target="_blank"
            style="position: absolute; right: 4px; top: 4px"
            small
            >{{ $t('How to use') }}</v-btn
          >
          <v-col cols="12">
            <v-row>
              <v-col :cols="isMobile ? 12 : 2">
                <v-img
                  :src="
                    account ? account.picture_url : businessProfile.picture_url
                  "
                  :width="isMobile ? '80px' : '150px'"
                  min-width="60px"
                  max-width="100%"
                  aspect-ratio="1"
                  contain
                  style="background-color: #e0e0e0; text-align: center"
                >
                  <template #placeholder>
                    <v-icon
                      :size="isMobile ? 32 : 50"
                      :style="`width: ${
                        isMobile ? '32px' : '100px'
                      }; height: 100%`"
                      >mdi-account</v-icon
                    >
                  </template>
                </v-img>
              </v-col>
              <v-col :cols="isMobile ? 12 : 10">
                <h1 class="primary--text mb-2">
                  {{ account ? account.name : businessProfile.name }}
                </h1>
                <v-row>
                  <v-col cols="3" class="py-2">{{ $t('id') }}</v-col>
                  <v-col cols="9" class="py-2">
                    {{ businessProfile.name || businessProfile.id }}
                  </v-col>
                  <v-col cols="3" class="py-2">{{ $t('your_package') }}</v-col>
                  <v-col cols="9" class="py-2">
                    <v-chip color="primary" v-if="packageGroup.length !== 0">
                      {{
                        packageGroup[0].is_free && isExpired
                          ? $t('Free')
                          : quota + ' ' + $t('Pieces')
                      }}
                    </v-chip>
                    <v-chip color="primary" style="padding-right: 2px" v-else>
                      {{ $t('free') }}
                      <v-dialog v-model="toggleRemark" width="500">
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="ml-2"
                            style="background-color: #ffffff"
                            v-on="on"
                          >
                            <v-icon size="18" color="primary">mdi-help</v-icon>
                          </v-btn>
                        </template>

                        <v-card style="opacity: 1">
                          <v-card-title class="lighten-2" primary-title>
                            {{ $t('free trial terms') }}
                          </v-card-title>

                          <v-card-text>
                            <ul>
                              <li>
                                {{
                                  $t(
                                    'Customers who apply for the new Rich menu can edit settings 2 times, free for 7 days.'
                                  )
                                }}
                              </li>
                              <li>
                                {{
                                  $t(
                                    "After 7 days, if the Rich menu is installed on Line OA, the Rich menu will still be available. but can't edit, can only press 'Disconnect' or 'Unlock to edit'."
                                  )
                                }}
                              </li>
                            </ul>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              flat
                              class="btn-custom"
                              @click="toggleRemark = false"
                            >
                              {{ $t('Back') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-chip>
                  </v-col>
                </v-row>
                <p></p>
                <p></p>
                <p></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <packages-detail />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PackagesDetail from '../components/PackagesDetail.vue'
import configUrl from '@/config'
import moment from 'moment'

export default {
  components: { PackagesDetail },
  data: () => ({
    quota: 0,
    toggleRemark: false,
    packageGroup: [],
    how_to_use_blog: configUrl.how_to_use_blog,
    isExpired: true
  }),
  computed: {
    ...mapGetters({
      businessProfile: 'login/businessProfile',
      account: 'ssoAccount/getAccountStore'
    })
  },
  async mounted() {
    await this.getLineRichmenuPackageByAccount()
  },
  methods: {
    async getLineRichmenuPackageByAccount() {
      var res = await this.$store.dispatch(
        'lineRichmenuManager/lineRichmenuPackageByAccount'
      )
      if (res) {
        this.$store.dispatch('setOverlay', false)
        var quota = null
        this.packageGroup = res.data.data
          .map((el) => {
            let a = moment(el.expired_timestamp)
            let b = moment()
            quota += el.qouta
            return {
              ...el,
              expiredTime: a.diff(b),
              expiredDay: a.diff(b, 'days')
            }
          })
          .sort(function (a, b) {
            return new Date(a.created_timestamp) - new Date(b.created_timestamp)
          })

        this.quota = quota
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
